module.exports = "/images/insurance.svg?504ff015dfcfe4b8bf9da500c069f16b";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/insurance.svg
// module id = 86
// module chunks = 1